import { PalettesProps } from "@ant-design/colors";

import Toby from "./toby";

import { PresetColor } from "types/config";
import { PaletteThemeProps } from "types/theme";

// ==============================|| PRESET THEME - TOBY ONLY ||============================== //

export default function Theme(
  colors: PalettesProps,
  _presetColor: PresetColor,
): PaletteThemeProps {
  return Toby(colors);
}
